// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1VKgF","checkboxCol":"Table_checkboxCol__1waFR","emailCol":"Table_emailCol__3e53w","actionCol":"Table_actionCol__2te7p"};